import { createLogger } from '../../utils/logger';

class SoundEffectsService {
  private readonly logger = createLogger('SoundEffectsService');
  private readonly queue: string[] = [];
  private isPlaying = false;

  preload(src: string): void {
    const audio = new Audio(src);
    audio.load();
    this.logger.debug('Preloaded sound effect', { src });
  }

  enqueue(src: string): void {
    this.queue.push(src);
    this.logger.debug('Queued sound effect', {
      src,
      queueSize: this.queue.length
    });

    if (!this.isPlaying) {
      this.playNext();
    }
  }

  private playNext(): void {
    const nextSrc = this.queue.shift();
    if (!nextSrc) {
      this.isPlaying = false;
      return;
    }

    this.isPlaying = true;
    const audio = new Audio(nextSrc);

    const onPlaybackDone = () => {
      audio.removeEventListener('ended', onPlaybackDone);
      audio.removeEventListener('error', onPlaybackDone);
      this.playNext();
    };

    audio.addEventListener('ended', onPlaybackDone);
    audio.addEventListener('error', onPlaybackDone);

    audio.play().catch((error) => {
      this.logger.warn('Failed to play sound effect', { src: nextSrc, error });
      onPlaybackDone();
    });
  }
}

export const soundEffectsService = new SoundEffectsService();
